import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

import { useAIParserSession } from "./use-ai-parser-session"

type Data = {
  sessionId: string
  filename: string
}

function deleteDocument(data: Data) {
  const { sessionId, filename } = data

  return api.delete(`/parser/delete-document?session_id=${sessionId}&filename=${filename}`)
}

export function useDeleteDocumentMutation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { currentSessionId } = useAIParserSession()

  return useMutation({
    mutationFn: deleteDocument,
    onSuccess: async (_, data) => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.fullSession(currentSessionId ?? ""),
      })
      toast.success(t("pages.ai_parser.toasts.document_deleted", { filename: data.filename }))
    },
  })
}
